import { IBanksPikContract } from '../repositories/special-promos-custom/entities/ContentBlocks/BanksPikContract';
import { IBank } from '../types/bank';

export function prepareBanks(response: IBanksPikContract[]): IBank[] {
  return response.map(contract => {
    return {
      bankName: contract.bankName,
      icon: contract.icon,
      licenseText: contract.licenseText,
      initialInstallment: contract.initialInstallment,
      amount: contract.amount,
      rate: contract.rate,
      maxTerm: contract.maxTerm,
    };
  });
}
